import api from "./apiBase";

const MODULE = "order-item-plates-print-attempts";

function getOrderProductionData(orderId) {
  return api.get(`${MODULE}/order/${orderId}`);
}

function getOrderPrintAttempts(orderId) {
  return api.get(`${MODULE}/${orderId}`);
}

function createPrintAttempts(data) {
  return api.post(`${MODULE}`, data);
}

export { getOrderProductionData, getOrderPrintAttempts, createPrintAttempts };
